module.exports = __webpack_public_path__ + "media/images/checkout/garantia-7-dias-9954934000cc0ddd8e2137e1fe96f156.png";